import { render, staticRenderFns } from "./NoResultsPlaceholder.vue?vue&type=template&id=401fd109&scoped=true"
var script = {}
import style0 from "./NoResultsPlaceholder.vue?vue&type=style&index=0&id=401fd109&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "401fd109",
  null
  
)

export default component.exports